import { Component, Input, OnChanges } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-garmin-circles',
  templateUrl: './garmin-circles.component.html',
  styleUrls: ['./garmin-circles.component.scss'],
})
export class GarminCirclesComponent implements OnChanges {

  @Input() activity: Activity | Partial<Activity>;
  measurementType='km';
  isImperial = localStorage.getItem('imperial') && localStorage.getItem('imperial')==='true';

  constructor() { }

  ngOnChanges() {
    this.measurementType = this.isImperial ? 'mi' : 'km';
  }

}
